module.exports = __webpack_public_path__ + "img/rider.9137062c.jpg";